import { TSourceWebSegment } from 'apps/fleet-planner/context/track-conversion-source/types'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'

export const getSavedLaneSourceSegment = (
  sourceType: BookableShipmentSavedSearch['sourceType']
): TSourceWebSegment | null => {
  if (sourceType === 'dispatcher_created') {
    return 'lane_alert_dispatcher_created'
  }
  if (sourceType === 'cm_created') {
    return 'lane_alert_cm_created'
  }
  return null
}
